module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAATxJREFUOE/N0zEoxGEYx/Hv7z9TNgbFZlT/UxaxY2XSSRaDciO5QZfFoNzApChZjIqyyWARxWRUxCoDuuH96X/dv/5dF4cb7h3f530+vc/zPq9o0VKLHNoUiuP4VNLIP8q8rZYWx/G0pFlg/LeY7QtgqwrlcrkPoGi7X9Jis5jtfeBS0nYKvQGdwC5wA+z8hIUQliX1SCoAn/VQkn8OlG0fSOqoB21XJM3YzkuarMUbQkns3vaapA2gL4O9AEu2VyUNZvYbQ7YfJCXQawihKGkIuAshlKIoSm65Agx8C9m+AkqSkkZ2AfO2u6Moegwh7EmqAHnbBUljDUuzfQQcA0l/slP/BPRm+2V7ARiWNJdt9juwWTtY/OnF0rjtMvAsaT19tWQYJ4CpZpHMuZMQwmEKnQGjf0DSlOv2+/1fUzh5JcgNGRYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dianhua(1).png
// module id = ZDeO
// module chunks = 26